import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { sec } from "../../../security";

const apiServerUrl = process.env.REACT_APP_HAISTACK_API_URL;

export const schoolApi = createApi({
  reducerPath: "school",
  tagTypes: ["Schools"],
  baseQuery: fetchBaseQuery({
    baseUrl: apiServerUrl,
    prepareHeaders: async (headers) => {
      const token = await sec.getAccessTokenSilently()();

      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }

      return headers;
    }
  }),
  endpoints: (builder) => ({
    getSchools: builder.query({
      query: () => "api/v2/schools",
      transformResponse: (response: any) => {
        return response.schools;
      }
    })
  })
});

export const { useGetSchoolsQuery } = schoolApi;
